/**
 * @param {Array} data
 * @param {number} page
 * @param {number} rowsPerPage
 * @param {number|null} totalCount - If set, data is already paginated (server-side)
 * @returns {Array}
 */
export const getPaginatedData = (data, page, rowsPerPage, totalCount) => {
  if (totalCount != null) {
    return data;
  }
  const start = (page - 1) * rowsPerPage;
  const end = start + rowsPerPage;
  return data.slice(start, end);
};
